module.exports = __webpack_public_path__ + "static/img/loft-conversions.6970573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/loft-conversions.png
// module id = fHHI
// module chunks = 1